module.exports = __webpack_public_path__ + "img/family-make.64448bf4.png";